import { AnimatePresence } from "framer-motion";
import About from "pages/About";
import Albion from "pages/Albion";
import Bottle from "pages/Bottle";
import Card from "pages/Card";
import Chess from "pages/Chess";
import Domino from "pages/Domino";
import Game from "pages/Game";
import Home from "pages/Home";
import Yes from "pages/Yes";
import { Route, Routes, useLocation } from "react-router-dom";

export default (props) => {
  const location = useLocation();
  const duration = 0.2;

  return (
    <AnimatePresence exitBeforeEnter>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home duration={duration} />} />
        <Route path="card" element={<Card duration={duration} />} />
        <Route path="about" element={<About duration={duration} />} />
        <Route path="yes" element={<Yes duration={duration} />} />
        <Route path="albion" element={<Albion duration={duration} />} />
        <Route path="game" element={<Game duration={duration} />} />
        <Route path="bottle" element={<Bottle duration={duration} />} />
        <Route path="chess" element={<Chess duration={duration} />} />
        <Route path="domino" element={<Domino duration={duration} />} />
      </Routes>
    </AnimatePresence>
  );
};
